import { formatCurrencyString } from './formatCurrencyString';

export const formatPrice = (
  value: string | number | undefined | null
): string => (value ? formatCurrencyString(value) : '$0.00 USD');
